<template>
  <div class="tabs-content" eager>
    <div class="tabs-content__tabs">
      <div class="tabs-content__wrapper">
        <div class="tabs-content__row tabs-content__header">
          <button
            :class="[
              'tabs-content__tabs-btn',
              { 'tabs-content__tabs-btn--selected': tab.isSelected }
            ]"
            @click="selectTab(tab.title)"
            v-for="tab in tabs"
            :key="tab.title"
          >
            {{ tab.title }}
          </button>
        </div>
      </div>
    </div>
    <div class="tabs-content__wrapper">
      <div class="tabs-content__row">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    preSelected: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    tabs: [],
    selected: ""
  }),
  methods: {
    selectTab(title = "") {
      if (title.length > 0) this.selected = title;

      this.tabs.forEach(tab => {
        tab.$data.isSelected = this.selected === tab.title;
      });
    }
  },
  mounted() {
    this.tabs = this.$children;
    this.$nextTick(function() {
      if (this.tabs.length > 0) {
        if (this.preSelected !== "") {
          this.selectTab(this.preSelected);
        } else {
          this.selected = this.tabs[0].title;
          this.tabs[0].$data.isSelected = true;
        }
      }
    });
  }
};
</script>

<style lang="scss">
@import "../../scss/base/variables.scss";
@import "../../scss/base/_nitty";

.tabs-content {
  &__wrapper {
  }

  &__row {
    display: flex;
    justify-content: stretch;
  }

  &__tabs {
    .tabs-content__wrapper {
      @include grid-container();
    }

    font-size: 0;
    position: relative;
    background: #7d858e;
  }
  &__tabs-btn {
    margin: 0;
  }
}

.tabs-content__tabs-btn {
  border: 0;
  cursor: pointer;
  flex: 1;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.38em;
  padding: 22px;
  text-align: center;
  background: transparent;
  color: #fff;
  font-weight: 500;
  border-right: 1px solid #fff;
  transition: all ease 0.3s;

  &:hover {
    background: #63686d;
  }

  &:last-child {
    border-right: none;
  }

  &:focus,
  &:active {
    outline: none;
  }

  &--selected,
  &--selected:hover {
    background-color: $brand-orange;
  }
}

@media all and(max-width: 675px) {
  .tabs-content {
    &__header {
      overflow-x: scroll;
    }
    &__wrapper {
      width: 100% !important;
      margin-left: 0;
      margin-right: 0;
      padding-left: 0;
      padding-right: 0;
    }
    &__tabs-btn {
      width: 200px;
      min-width: 200px;
    }

    .tab-content {
      margin: 0 auto;
    }
  }
}
</style>
